import script from "./chat.vue?vue&type=script&setup=true&name=Chat&lang=js"
export * from "./chat.vue?vue&type=script&setup=true&name=Chat&lang=js"

import "./chat.vue?vue&type=style&index=0&id=6bcfd4e6&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\hujing\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bcfd4e6"]])

export default __exports__